import type { FotoRecibo } from "./pdfRecibo"

/** Lo que manda el portal de transporte (`schemas/transporte.py`). */

export type Empresa = {
  id: number
  razon_social: string
  rif: string
  domicilio: string | null
  telefono: string | null
  correo: string | null
  logo_documento_id: number | null
  activo: boolean
}

export type Vehiculo = {
  id: number
  empresa_id: number
  placa: string
  placa_remolque: string | null
  marca: string | null
  modelo: string | null
  color: string | null
  anio: number | null
  activo: boolean
}

export type Chofer = {
  id: number
  empresa_id: number | null
  nombres: string
  apellidos: string
  cedula: string
  telefono: string | null
  licencia_grado: string | null
  licencia_vence: string | null
  activo: boolean
}

export type Documento = {
  id: number
  dueno: string
  dueno_id: number
  tipo: string
  vence: string | null
  nombre_original: string
  mime: string
  creado_en: string
}

export type Linea = {
  cantidad: string
  descripcion: string
  contenedor: string | null
  tamano: string | null
  precio_unitario: string
  gravado: boolean
}

export type Recibo = {
  id: number
  intermediario_id: number
  asignacion_id: number | null
  numero: number | null
  estado: "BORRADOR" | "EMITIDO" | "RECIBIDO" | "ANULADO"
  empresa_id: number | null
  vehiculo_id: number | null
  chofer_id: number | null
  fecha: string
  moneda: "BS" | "USD" | "EUR"
  expediente_numero: string | null
  bl: string | null
  origen: string | null
  destino: string | null
  condiciones_pago: string
  observaciones: string | null
  total: string | null
  emitido_en: string | null
  recibido_en: string | null
  anulado_en: string | null
  motivo_anulacion: string | null
  creado_en: string
  lineas: Linea[]
  snapshot: FotoRecibo | null
}

/** Una carga asignada desde el 2.0 (lo que ve el intermediario: sin costos). */
export type Asignacion = {
  id: number
  numero: string
  asignado_en: string
  carga: {
    bl: string | null
    buque: string | null
    eta: string | null
    descripcion_mercancia: string | null
    tipo_mercancia: string | null
    tipo_carga: string | null
    cantidad_carga: string | null
  }
  fletes: { concepto: string | null; cantidad: string | null }[]
  /** Cuántos recibos tiene por estado. */
  recibos: Partial<Record<Recibo["estado"], number>>
  reportado_en: string | null
}

export const ESTADOS: Record<Recibo["estado"], string> = {
  BORRADOR: "Borrador",
  EMITIDO: "Emitido",
  RECIBIDO: "Recibido por administración",
  ANULADO: "Anulado",
}

export const TONO_ESTADO = {
  BORRADOR: "neutro",
  EMITIDO: "info",
  RECIBIDO: "exito",
  ANULADO: "peligro",
} as const

export const MONEDAS = { BS: "Bs.", USD: "USD", EUR: "EUR" } as const

export const TAMANOS: Record<string, string> = {
  "20": "20'",
  "40": "40'",
  "40HC": "40' HC",
  "45": "45'",
  CARGA_SUELTA: "Carga suelta",
}

export type TiposDocumento = {
  tipos: Record<string, Record<string, string>>
  obligatorios: Record<string, string[]>
}

export const numero = (n: number | null) => (n === null ? "—" : String(n).padStart(6, "0"))
